module.exports = __webpack_public_path__ + "img/switchapparrow.b884eb96.svg";